var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStanderInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22C9.4 22 9 21.5 9 21V20H15V21C15 21.5 14.6 22 14 22H10ZM5 9C5 5.1 8.1 2 12 2C15.9 2 19 5.1 19 9C19 11.3 17.8 13.4 16 14.7V17C16 17.5 15.6 18 15 18H9C8.4 18 8 17.5 8 17V14.7C6.2 13.5 5 11.4 5 9ZM7.80469 8.81006L9.90589 10.9113L16.0959 4.72748L17.4102 6.17676L9.90589 13.681L6.41016 10.1853L7.80469 8.81006Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22C9.4 22 9 21.5 9 21V20H15V21C15 21.5 14.6 22 14 22H10ZM5 9C5 5.1 8.1 2 12 2C15.9 2 19 5.1 19 9C19 11.3 17.8 13.4 16 14.7V17C16 17.5 15.6 18 15 18H9C8.4 18 8 17.5 8 17V14.7C6.2 13.5 5 11.4 5 9ZM7.80469 8.81006L9.90589 10.9113L16.0959 4.72748L17.4102 6.17676L9.90589 13.681L6.41016 10.1853L7.80469 8.81006Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStanderInactive);
export default __webpack_public_path__ + "static/media/StanderInactive.cea276767ea8857fc569160a6d996729.svg";
export { ForwardRef as ReactComponent };